import { z } from "zod";

export const EditarGruposSchema = z.object({
    nome: z.string()
        .nonempty("O nome do grupo é obrigatório.")
        .min(3, "O nome do grupo deve ter no mínimo 3 caracteres")
        .max(100, "O nome do grupo deve ter no máximo 100 caracteres"),

    cod_grupos: z.union([
        z.string().nonempty().refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
            message: "O código do grupo deve ser um número válido maior que 0."
        }),
        z.number().min(1, "O código do grupo deve ser um número válido maior que 0.")
    ]),

    status: z.enum(["S", "N"], {
        errorMap: () => ({ message: "O status deve ser 'S' ou 'N'" })
    })
});